import {
  HEART_BEAT_RESPONSE_HANDLER,
  REGISTER_RESPONSE_HANDLER,
  FORGOTPASS_RESPONSE_HANDLER,
} from "../actions/types";

export default (state = {}, action) => {
  let status = 200;
  let data = {};
  let notificationType = "info";
  if (
    action.payload != undefined &&
    typeof action.payload.status != "undefined"
  ) {
    status = action.payload.status;
    notificationType = "success";
    if (status >= 400) {
      notificationType = "error";
    }
    data = action.payload.data;
  }

  let response = {
    notificationType: notificationType,
    type: action.type,
    status: status,
    action: "GET",
  };
  switch (action.type) {
    case HEART_BEAT_RESPONSE_HANDLER:
      response["data"] = action.payload.data;
      response["notificationType"] = "warning";
      break;
    case REGISTER_RESPONSE_HANDLER:
      response["data"] = action.payload.data;
      response["action"] = "ACTION";
      break;
    case FORGOTPASS_RESPONSE_HANDLER:
      response["data"] = action.payload.data;
      response["action"] = "ACTION";
      break;
    default:
      return state;
  }
  return response;
};
